<div class="filter-group-modal">
    <div class="facet-groups" *ngIf="data?.facetGroups">
        <div class="facet-group" *ngFor="let facetGroup of data.facetGroups">
            <div *ngIf="facetGroup.label" class="label">{{facetGroup.label}}</div>
            @defer {
                <finder-ra-checkbox
                    class="checkbox"
                    *ngFor="let facet of facetGroup.facets"
                    alignment="top"
                    [checked]="facet.value"
                    (checkedChanged)="onCheck($event, facet)">
                    {{facet.label}}
                    <div class="description" *ngIf="facet.description">
                        {{facet.description}}
                    </div>
                </finder-ra-checkbox>
            }
        </div>
    </div>
    <finder-button theme="primary" (click)="dismiss()">{{ data?.doneLabel }}</finder-button>
</div>
